import { FACILITY_ADDRESSES } from "@/lib/shipment/constants";

export default function ratingSchema() {
  function organizationSchema() {
    const schema = {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "JustShip",
      "@id": "https://justship.sg",
      url: "https://justship.sg",
      description: "Cheapest International Shipping Singapore",
      address: {
        "@type": "PostalAddress",
        addressLocality: FACILITY_ADDRESSES.JUSTSHIP.city,
        addressRegion: FACILITY_ADDRESSES.JUSTSHIP.country,
        postalCode: FACILITY_ADDRESSES.JUSTSHIP.postalCode,
        streetAddress: FACILITY_ADDRESSES.JUSTSHIP.fullAddress,
      },
    };
    return {
      __html: JSON.stringify(schema),
    };
  }
  function productSchema() {
    const schema = {
      "@context": "https://schema.org",
      "@type": "Product",
      name: "JustShip - Cheapest International Shipping Singapore",
      aggregateRating: {
        "@type": "AggregateRating",
        ratingValue: "4.8",
        reviewCount: "1028",
      },
    };
    return {
      __html: JSON.stringify(schema),
    };
  }
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={organizationSchema()}
        key="organization-jsonld"
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={productSchema()}
        key="product-jsonld"
      />
    </>
  );
}
